export default Object.freeze({
  // AI_JOB_DELETE: 'AI_JOB_DELETE',
});
